// @flow
import { REDIRECT } from "../Actions/actionTypes";

export const redirect = (url: string) => ({
  type: REDIRECT,
  url,
});
